import { Box, Grid, Paper, Tabs, Tab } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const NurseNav = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("/nurse");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = ["/nurse", "/nurse/bedPatient"];

    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/nurse");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" }, // Ensures tabs have consistent width
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor: value === "/nurse" ? "#007174" : "white",
                color: value === "/nurse" ? "white" : "black",
              }}
              label={t("nurse.dashboard")}
              value="/nurse"
              component={NavLink}
              to="/nurse"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/nurse/bedPatient" ? "#007174" : "white",
                color: value === "/nurse/bedPatient" ? "white" : "black",
              }}
              label={t("nurse.bedPatient")}
              value="/nurse/bedPatient"
              component={NavLink}
              to="/nurse/bedPatient"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default NurseNav;
